module.exports = __webpack_public_path__ + "static/media/Sayali Mate.6dedb231.jpeg";